import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { ProductsRepoartApi } from '../../Api/SupplierServices';
import toEnglishDigits from '../../Functions/PersionToEn';
import { errorToast } from '../../Utils/Toast/Toast';
import DatePickerInRange from '../DatePickerInRange/DatePickerInRange';
import LoadingComponet from '../LoadingComponet/LoadingComponet';
import Style from './ProductsSold.module.css'
const ProductsSold = () => {
    const[porductRepoarts,setProductsRepoart]=useState()
    const[startTime,setStartTime]=useState('')
    const[endTime,setEndTime]=useState('')
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null
      });

    
      
      const minimumDate = {
        year: parseInt(startTime.split('-')[0]),
        month:  parseInt(startTime.split('-')[1]),
        day:  parseInt(startTime.split('-')[2])
      };
    
      const maximumDate = {
        year: parseInt(endTime.split('-')[0]),
        month:parseInt(endTime.split('-')[1]),
        day:parseInt(endTime.split('-')[2]),
      }

      const setOrderByDateHandler=()=>{
        getProductRepoart(selectedDayRange)
    }

    useEffect(() => {
        getProductRepoart()
    }, [])




    const getProductRepoart=(date)=>{
        let dateRange={
          start_date:date===undefined?'':`${date.from.year}-${date.from.month}-${date.from.day}`,
          end_date:date===undefined?'':`${date.to.year}-${date.to.month}-${date.to.day}`
        }
      ProductsRepoartApi(dateRange,(succ)=>{
          if(succ.status===1)
          {
            setProductsRepoart(succ)
              setStartTime(toEnglishDigits(succ.duration.start))
              setEndTime(toEnglishDigits(succ.duration.end))
          }
          else{
              errorToast(succ.message)
          }
      })
    }

    let loadingHandler=null
    if(porductRepoarts===undefined){
        loadingHandler=<LoadingComponet/>
    }
    else{
        loadingHandler=porductRepoarts.products.map(item=>{
            return(
                <li key={item.id} className={Style.EachPart__ul__li}>
                    <p className={Style.NameProduct}>{item.name}</p>
                    <p>{item.count} عدد</p>
                    {/* <span>{separate(250000)} تومان</span> */}
                </li>    
            )
        })
    }

    return (
        <div className={Style.ComponenHolder}>
            <div className={Style.DatePickerHolder}>
                <div>
                <DatePickerInRange       
                minimumDate={minimumDate}
                maximumDate={maximumDate} 
                placeholder={'بازه زمانی خودرا مشخص کنید'} 
                selectedDayRange={selectedDayRange}
                setSelectedDayRange={setSelectedDayRange}
                />
                </div>
                <span onClick={setOrderByDateHandler}>
                    <FontAwesomeIcon icon={faSearch}/>
                </span>
            </div>
            <ul className={Style.EachPart__ul}>
               {
                   loadingHandler
               }
            </ul>
        </div>
    )
}

export default ProductsSold
